import { Box, IconButton, Tooltip } from "@mui/material";
import { getBaseApiUrl, getUploadUrl } from "../service/ServiceApi";
import MusicVideoIcon from '@mui/icons-material/MusicVideo';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { useTheme } from "@mui/styles";
import DeleteIcon from '@mui/icons-material/Delete';
import { useState } from "react";

export default function AttachmentPreviewBox(props: { name: string; id: number | null; model: string; deleted?: boolean; fullImageWidth?: boolean; file?: File, onDelete?: () => void, systemAttachmentId?: number | null, systemAttachmentFile?: string | null }) {
    const { id, model, name, deleted, fullImageWidth, file, onDelete, systemAttachmentId, systemAttachmentFile } = props;
    const [expanded, setExpanded] = useState(false);
    let attachmentExt: string = (systemAttachmentFile || name || '').split('.').slice(-1)[0].toLowerCase();
    const theme = useTheme();
    let iconSize = 40;
    let backgroundColor = theme.palette.mode === 'dark' ? '#808080' : '#eee';
    let deleteIcon = null;
    if (onDelete && !deleted) {
        deleteIcon = <Tooltip sx={{ position: 'absolute', top: '-5px', right: '-5px', }} placement="top" title={'Remover anexo'}>
            <IconButton
                size='small'
                color="inherit"
                aria-label={'Remover anexo'}
                onClickCapture={onDelete}
            >
                <DeleteIcon style={{ fontSize: 24, color: 'red' }} />
            </IconButton>
        </Tooltip>;
    }

    if (!!deleted) {
        return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"} width={100} title={`Anexo "${name}" excluído`}>
            {deleteIcon}
            <DoNotDisturbIcon style={{ fontSize: iconSize }} />
        </Box>;
    }

    let attachmentUrl = file
        ? URL.createObjectURL(file)
        : (systemAttachmentId && systemAttachmentFile)
            ? `${getUploadUrl()}SystemAttachment/${systemAttachmentId}/${systemAttachmentFile}`
            : `${getUploadUrl()}${model}/${id}/${name}`;
    if (['png', 'jpeg', 'jpg', 'gif', 'jfif'].includes(attachmentExt)) {
        return <Box onClick={(e) => {
            if (e.ctrlKey || e.shiftKey || e.altKey) {                
                window.open(attachmentUrl, '_blank');
            } else {
                setExpanded(!expanded);
            }
        }} sx={{
            backgroundColor,
            position: 'relative',
            float: 'left',
            margin: '5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: expanded ? 'auto' : (fullImageWidth ? undefined : 100),
            minWidth: 100,
            maxWidth: '100%',
            height: expanded ? 'auto' : 80,
            cursor: 'pointer',
            border: '1px solid #ccc'
        }}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <img style={{ maxWidth: '100%', height: 'auto', maxHeight: '100%' }} src={attachmentUrl} />
            </a>
        </Box>;
    } else if (attachmentExt === 'pdf') {
        return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"} width={100}>
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <PictureAsPdfIcon style={{ fontSize: iconSize }} />
            </a>
        </Box>;
    } else if (['txt', 'csv', 'xls', 'doc', 'docx'].includes(attachmentExt)) {
        return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"} width={100}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <TextSnippetIcon style={{ fontSize: iconSize }} />
            </a>
        </Box>;
    } else if (['mp4', 'wmv'].includes(attachmentExt)) {
        return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"} width={100}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <OndemandVideoIcon style={{ fontSize: iconSize }} />
            </a>
        </Box>;
    } else if (attachmentExt === 'mp3') {
        return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"} width={100}>
            {deleteIcon}
            <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
                <MusicVideoIcon style={{ fontSize: iconSize }} />
            </a>
        </Box>;
    }

    return <Box display={"flex"} alignItems={"center"} sx={{ backgroundColor, position: 'relative', float: 'left', margin: '5px', border: '1px solid #ccc' }} justifyContent={"center"}>
        {deleteIcon}
        <a style={{ display: 'flex', color: 'inherit', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' }} href={attachmentUrl} target="_blank">
            <AttachFileIcon style={{ fontSize: iconSize }} />
        </a>
    </Box>;
}